/**
 * String utility functions
 */

/**
 * Escape HTML special characters to prevent XSS
 */
export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Truncate string from the end, adding "..." suffix
 */
export function truncate(str: string, maxLength: number): string {
  if (str.length <= maxLength) return str;
  return str.substring(0, maxLength - 3) + '...';
}

/**
 * Truncate string from the start, adding "..." prefix
 * Useful for showing most recent text (e.g., live typing preview)
 */
export function truncateStart(str: string, maxLength: number): string {
  if (str.length <= maxLength) return str;
  return '...' + str.substring(str.length - maxLength + 3);
}
